import React from 'react';
import Avatar from 'react-avatar'
import Image from 'react-bootstrap/Image'
import Uppy from '@uppy/core'
// import Instagram from '@uppy/instagram'
import { Dashboard } from '@uppy/react'
import AwsS3 from '@uppy/aws-s3'
import * as moment from 'moment-timezone'
import analytics from 'util/analytics';
import '@uppy/core/dist/style.css'
import '@uppy/dashboard/dist/style.css'

function Uploader (props) {
    const {filePath} = props
    const {onChange} = props
    const uppy = React.useMemo(() => {
      return Uppy({
        autoProceed: true,
        id: "Uploader",
            restrictions: {
                maxNumberOfFiles: 1,
                // maxFileSize: 180000000,
                // maxFileSize: 1500000000,
                maxFileSize: 5000000000,
                allowedFileTypes: ['image/*','video/mp4', 'video/quicktime', 'application/pdf', 'audio/*']
            }
        })
        // .use(Instagram, {
        //     title: 'IG TV',
        //     companionUrl: process.env.REACT_APP_API_BASE_URL + '/storage/companion'
        // })
        .use(AwsS3, {
                limit: 1,
                timeout: 1000 * 60 * 60,
                getUploadParameters(file) {
                // Send a request to our signing endpoint.
                    return fetch(process.env.REACT_APP_API_BASE_URL + '/storage/getSignedUrl', {
                            method: 'post',
                            // Send and receive JSON.
                            headers: {
                                accept: 'application/json',
                                'content-type': 'application/json',
                            },
                            body: JSON.stringify({
                                filename: (filePath ?? "files/") + moment().unix() + file.name,
                                contentType: file.type,
                            }),
                        })
                        .then(response => {
                            // console.log("signedUrl: ", response.json())
                            return response.json()
                        });
                },
        })
        .on('upload-error', (file, error, response) => {
            analytics.track("Error Uploading FormFile", {
                error: {...error},
                resposne: {...response},
                fileId: file.id
            })
            if (error.isNetworkError) {
                window.alert("This upload may have failed due to a network firewall or issues with your internet service provider")
                return
            }
        })
        .on('upload-success', (result) => {
            console.log("Upload success: ", result)
            const storagePath = result?.meta?.storagePath
            const type = result?.meta?.type
            if (!storagePath || !type) { return }
            fetch(process.env.REACT_APP_API_BASE_URL + '/storage/getDownloadUrl', {
                method: 'post',
                headers: {
                    accept: 'application/json',
                    'content-type': 'application/json',
                },
                body: JSON.stringify({
                    filename: storagePath,
                    contentType: type,
                }),
            }).then(response => {
                return response.json()
            }).then(json => {
                console.log("downloadurl: ", json)
                if (onChange) {
                    onChange(json)
                }
            })
        })
    }, [])
    React.useEffect(() => {
      return () => uppy.close()
    }, [])
  
    return (
      <Dashboard
        height={250}
        showLinkToFileUploadResult={false}
        uppy={uppy}
        plugins={[]}
        {...props}
      />
    )
  }

function FormFile({ filePath, type, name, label, sublabel, register, defaultName, ...otherProps}) {

    const {fileSelection, onDemandSelection} = otherProps;
    const {fileUrl} = otherProps;
    const { imageUrl } = otherProps
    const {onDemand } = otherProps

    // const {avatarImage, squareImage} = otherProps;

    const [imagePreviewUrl, setImagePreviewUrl] = React.useState(
        imageUrl ? imageUrl : null
    )

    const [fileName, setFileName] = React.useState(null)

    const [file, setFile] = React.useState(null);
    let fileInput = React.createRef();

    const handleChange = e => {
        if (e.onDemand && onDemandSelection) {
            onDemandSelection(e.onDemand)
        }
    }
    const handleImageChange = e => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
          setFile(file);
          setImagePreviewUrl(reader.result);
          console.log("reader result: ", reader.result)
          console.log("selected file 1: ", file)
          if (fileSelection) {
            console.log("selected file 2")
            fileSelection(file);
          }
        };
        if (file) {
          reader.readAsDataURL(file);
        }
      };
    const handleRemove = () => {
        setFile(null);
        setImagePreviewUrl(null)
        // setImagePreviewUrl(props.avatar ? defaultAvatar : defaultImage);
        fileInput.current.value = null;
        // ref.current.value = null;
    };
    const handleClick = () => {
        fileInput.current.click();
        // ref.current.click()
    };

    const {fullSize} = otherProps;
    var leftCol = fullSize ? "col-md-3" : "col-md-2"
    var rightCol = fullSize ? "col-md-9" : "col-md-6"

    const [editMode, setEditMode] = React.useState(false)

    return (
    <div className="form-group row">
        {label && (<label className={`${leftCol} col-form-label`}>
            <h6>{label}</h6>
            {sublabel && (<small>{sublabel}</small>)}
        </label>)}

        <div className={`${rightCol}`}>
            {onDemand && !editMode ? (
                <>
                {onDemand.fileType.includes("video") ? (
                    <video className="w-100" controls name="media">
                        <source type={onDemand.fileType === 'video/quicktime' ? 'video/mp4' : onDemand.fileType} src={onDemand.downloadUrl}></source>
                    </video>
                ) : (
                    <a href={onDemand.downloadUrl} target="_blank" className="mr-3 btn btn-primary">Download</a>
                )}
                <button onClick={() => setEditMode(true)} className="btn btn-primary">Edit</button>
                </>
            ) : (
                <Uploader
                    filePath={filePath}
                    onChange={handleChange}
                />
            )}
        </div>

    </div>
    );
}

export default FormFile
